import { render, staticRenderFns } from "./FinanceOverview.vue?vue&type=template&id=945ea834&scoped=true"
import script from "./FinanceOverview.vue?vue&type=script&lang=js"
export * from "./FinanceOverview.vue?vue&type=script&lang=js"
import style0 from "./FinanceOverview.vue?vue&type=style&index=0&id=945ea834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945ea834",
  null
  
)

export default component.exports